import type { FormatterMap, ProductRoutesOptions, RouteList } from '@grandvisionhq/frk-routing'
import { createSimpleFormatter } from '@grandvisionhq/frk-routing'
import {
  createAuthFormatters,
  createCheckoutFormatters,
  createMyAccountFormatters,
  productDetailFormatters,
  productListFormatter,
} from '@grandvisionhq/www-next/formatters'

const productRoutesOptions: ProductRoutesOptions = {
  accessories: 'eyecare-and-accessories',
  'contact-lenses': 'contact-lenses',
  frames: 'glasses',
  sunglasses: 'sunglasses',
}

export const localRouteFormatters: FormatterMap = {
  home: createSimpleFormatter('/'),

  'cart.overview': createSimpleFormatter('cart'),
  'download.invoice': createSimpleFormatter('download-invoice'),
  'appointments.book': createSimpleFormatter('book-appointment'),
  'appointments.cancel': createSimpleFormatter('cancel-appointment'),
  'appointments.reschedule': createSimpleFormatter('reschedule-appointment'),
  ...createMyAccountFormatters(),
  ...createAuthFormatters(),
  'order.confirm': createSimpleFormatter('order/confirm'),
  'express-checkout': createSimpleFormatter('express-checkout'),
  'express.checkout.login': createSimpleFormatter('express-user-checkout'),
  ...createCheckoutFormatters({
    path: 'checkout',
    children: { login: 'login', shipping: 'shipping', overview: 'overview', payment: 'payment' },
  }),
  ...productDetailFormatters(productRoutesOptions),
  ...productListFormatter(productRoutesOptions),
  wishlist: createSimpleFormatter('/wishlist'),
  returns: createSimpleFormatter('/returns'),
  'returns.select-items': createSimpleFormatter('/returns/select-items'),
  'returns.confirmation': createSimpleFormatter('/returns/confirmation'),
}

export const routes: RouteList = [
  ['/', 'home'],

  ['/checkout/login', 'checkout.login'],
  ['/checkout/shipping', 'checkout.shipping'],
  ['/checkout/overview', 'checkout.overview'],
  ['/checkout/payment', 'checkout.payment'],
  ['/api/payment-callback', 'payment.callback'],
  ['/order/confirm', 'order.confirm'],

  ['/express-checkout', 'express-checkout'],

  ['/book-appointment{/*path}', 'appointments.book'],
  ['/reschedule-appointment', 'appointments.reschedule'],
  ['/cancel-appointment', 'appointments.cancel'],
]
